export const developerRoleId = 2
export const adminRoleId = 3
export const dispatcherRoleId = 4
export const guestRoleId = 5